import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    selector: '[cardToggleEvent]'
})
export class CardToggleDirective {
    constructor(private el: ElementRef) { }

    @HostListener('click', ['$event'])
    onToggle($event: any) {
        $event.preventDefault();
        this.el.nativeElement.classList.toggle('icon-up');
    }
}



// WEBPACK FOOTER //
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/app/shared/card/card-toggle.directive.ts